import React, { useEffect } from 'react';
import './index.scss';
import { message } from 'antd';
import ChildHead from '../components/childHead';
import NOData from '@/components/no-data';
import AddressCell from './address-cell';
import { AppDispatch, RootState } from '@/redux/store';
import { getAddressList, setEditModalState } from '@/redux/address';
import { useDispatch, useSelector } from 'react-redux';

const Index: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { addressesList } = useSelector((state: RootState) => state.addressReducer);

  useEffect(() => {
    dispatch(getAddressList()); // 第一次进来获取收货地址列表
  }, [dispatch]);

  // 新增
  const addRecord = () => {
    if (addressesList.length >= 10) {
      message.error('已存在10条收货地址，请勿重复操作');
      return false;
    }
    dispatch(setEditModalState({ isAdd: true, open: true, title: '新增收货地址', id: '' }));
  };

  return (
    <div className="child-page-wrap">
      <div className="child-page">
        <ChildHead title="收货地址" rightText="新增收货地址" callback={addRecord} disableHandleBtn={addressesList.length >= 10} />
        <div className="child-content">
          {addressesList.length === 0 && <NOData />}
          {addressesList.map((item) => {
            return <AddressCell key={item.id} {...item} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default Index;
